import type { CustomRuleInstructionSource } from '@/generated/prisma/enums';

import { CustomRuleInstructionSource as PrismaCustomRuleInstructionSource } from '@/generated/prisma/enums';

export type { CustomRuleInstructionSource } from '@/generated/prisma/enums';

export const CUSTOM_RULE_INSTRUCTION_SOURCE = PrismaCustomRuleInstructionSource;
export const TEXT_CUSTOM_RULE_INSTRUCTION_SOURCE = PrismaCustomRuleInstructionSource.text;
export const FILE_PATHS_CUSTOM_RULE_INSTRUCTION_SOURCE =
  PrismaCustomRuleInstructionSource.file_paths;
export const DEFAULT_CUSTOM_RULE_INSTRUCTION_SOURCE = TEXT_CUSTOM_RULE_INSTRUCTION_SOURCE;

export const CUSTOM_RULE_INSTRUCTION_SOURCE_VALUES = [
  TEXT_CUSTOM_RULE_INSTRUCTION_SOURCE,
  FILE_PATHS_CUSTOM_RULE_INSTRUCTION_SOURCE,
] as const satisfies readonly CustomRuleInstructionSource[];
